import { CoreInitiativesTasksLinkName } from './name';
import { createDeleteAsyncSlice } from '@sonar-software/xuder';
import { deleteInitiativeTaskLink } from '@api';
import { rebuildArray } from '@lib';
import { updateInitiativeReferences } from '../../_idMap/actions';

export const coreInitiativesTasksLinkDeleteAsyncSlice = createDeleteAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [
			({ initiativeId, initiativeTaskId, sonarObjectId }) =>
				updateInitiativeReferences([
					{
						initiativeId,
						tasks: {
							toUpdateById: {
								id: initiativeTaskId,
								update: (entry) => ({
									...entry,
									sonarObjects: rebuildArray(
										entry.sonarObjects,
										{
											toRemoveById: sonarObjectId
										},
										{
											idSelector: (task) => task.sonarObjectId
										}
									)
								})
							}
						}
					}
				])
		]
	},
	name: CoreInitiativesTasksLinkName,
	receive: false,
	request: true,
	requestHandler: deleteInitiativeTaskLink
});
